import React, { FunctionComponent } from 'react'

import firebase from 'firebase/app'
import { getAuth, User as FirebaseUser } from 'firebase/auth'

import { WindowLocation } from '@reach/router'

import { navigate } from 'gatsby'
import CircularProgress from '@material-ui/core/CircularProgress'

export const isBrowser = (): boolean => typeof window !== 'undefined'

type PrivateRouteProps = {
  location: WindowLocation
  firebase: firebase.FirebaseApp
}

// TODO(alex): Figure out how to actually type the Component child/parameter so
// that TypeScript is happy with it.  Right now it passes through Babel to
// generate compatible React/JSX-compiler code for the intent, but it isn't
// strictly "correct" as we're really doing a string rewrite/template
// expansion... which is kind of nasty.
const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({
  location,
  firebase: firebaseApp,
  /* eslint-disable react/prop-types */
  component: Component,
  /* eslint-enable react/prop-types */
  ...rest
}) => {
  const [user, setUser] = React.useState<FirebaseUser | undefined>(undefined)

  React.useEffect(() => {
    if (isBrowser()) {
      return getAuth(firebaseApp).onAuthStateChanged((user) => {
        if (user) {
          // User is signed in
          setUser(user)
        } else {
          // User is not signed in
          setUser(undefined)

          void navigate('/sign-in', {
            state: {
              redirectSource: location?.pathname,
            },
          })
        }
      })
    }
  })

  return (
    <>
      {user === undefined ? (
        <CircularProgress size={24} />
      ) : (
        <Component
          location={location}
          user={user}
          firebase={firebaseApp}
          {...rest}
        />
      )}
    </>
  )
}

export default PrivateRoute
